/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SettingValueText
 */
export interface SettingValueText {
  /**
   *
   * @type {string}
   * @memberof SettingValueText
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SettingValueText
   */
  text?: string
  /**
   *
   * @type {string}
   * @memberof SettingValueText
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof SettingValueText
   */
  updatedAt?: string
}

export function SettingValueTextFromJSON(json: any): SettingValueText {
  return SettingValueTextFromJSONTyped(json, false)
}

export function SettingValueTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettingValueText {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    text: !exists(json, 'text') ? undefined : json['text'],
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at']
  }
}

export function SettingValueTextToJSON(value?: SettingValueText | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    text: value.text,
    created_at: value.createdAt,
    updated_at: value.updatedAt
  }
}
